export default __webpack_public_path__ + "static/training-8a65e5de5bf98b78000a5f28aaa8e3ca.jpg";